import { StyledEngineProvider, ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { useStore } from '@priolo/jon';
import MainOS from 'components/layout/MainOS';
import MsgBox from 'components/layout/MsgBox';
import SuspenseMsgCmp from 'components/layout/SuspenseMsgCmp';
import { Suspense, lazy, useEffect } from 'react';
import { Route, Switch } from "react-router-dom";
import layoutSo from 'stores/layout';
import userSo from 'stores/user';

import { CopilotKit } from '@copilotkit/react-core';
import "@copilotkit/react-ui/styles.css";
import CopilotErrorBoundary from 'components/copilotkit/CopilotErrorBoundary';
import PopUp from 'components/copilotkit/PopUp';
import chatSo from 'stores/copilot/chat';

const LoginPag = lazy(() => import("pages/login/LoginPag"));
const RequestPag = lazy(() => import('pages/login/RequestPag'));
const ResetPag = lazy(() => import('pages/login/ResetPag'));
const OtpCodePag = lazy(() => import('pages/login/OtpCodePag'));
const LandingPage = lazy(() => import("pages/landingpage/Pag"));


const copilotKitApiKey = import.meta.env.VITE_COPILOTKIT_API_KEY
let popupAgent = import.meta.env.VITE_COPILOTKIT_POPUP_AGENT ?? "chatbot_agent"


export default function AppOS() {

    // STORES
    useStore(userSo)
    // TODO: eliminare questa dipendenze e mettere "systemReady" in userSo o in un store apposito
    useStore(layoutSo)

    // HOOKs

    useEffect(() => {
        if (!userSo.isLogged() || !proxy) return
        chatSo.fetchToken()
    }, [userSo.isLogged()])


    // RENDER
    
    // disabilitato se esplicitamente in env oppure se c'e' un PROXY e non c'e' il TOKEN
    let proxy = userSo.state.config?.copilotkit?.proxy?.url ?? import.meta.env.VITE_COPILOTKIT_PROXY_URL
    if ( !!copilotKitApiKey) {
        proxy = null
        popupAgent = null
    }
    const copilotKitDisabled =
        !userSo.state.config?.copilotkit?.enabled
        || !userSo.isDebugger()
        || (!!proxy && !chatSo.state.token)
    if (layoutSo.state.systemReady === false) return null

    return <>
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={layoutSo.state.theme}>
                <CssBaseline />

                <MsgBox />

                <Suspense fallback={<SuspenseMsgCmp />}>
                    {!userSo.isLogged() ? (
                        <Switch>
                            <Route exact path="/password/request" component={RequestPag} />
                            <Route exact path="/password/reset" component={ResetPag} />
                            <Route exact path="/login/otp-code" component={OtpCodePag} />
                            <Route path={["/", "/login"]} component={LoginPag} />
                        </Switch>
                    ) : (
                        <Switch>
                            <Route path="/landingpage" component={LandingPage} />
                            <Route path="*">
                                <MainOS />
                            </Route>
                        </Switch>
                    )}
                </Suspense>

            </ThemeProvider>
        </StyledEngineProvider>

        {!copilotKitDisabled &&
            <CopilotErrorBoundary>
                <CopilotKit
                    runtimeUrl={proxy}
                    agent={popupAgent}
                    headers={{
                        'Authorization': 'Bearer ' + chatSo.state.token
                    }}
                    publicApiKey={copilotKitApiKey}
                >
                    <PopUp />
                </CopilotKit>
            </CopilotErrorBoundary>
        }
    </>;

}

